import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { OrderModalData } from '../../models/modal-data.model';
import { IOrder } from '../../models/order.model';

@Component({
  selector: 'app-order-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './order-modal.component.html',
  styleUrls: ['./order-modal.component.scss'],
})
export class OrderModalComponent implements OnInit {
  public orderForm!: FormGroup;
  public isEditMode = false;
  public isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    @Inject('MODAL_DATA') private data: OrderModalData,
    @Inject('MODAL_CLOSE') private modalClose: (result: IOrder | null) => void
  ) {}

  ngOnInit(): void {
    this.isEditMode = this.data?.mode === 'edit';
    this.initForm();

    if (this.isEditMode && this.data?.order) {
      this.patchFormValues(this.data.order);
    }
  }

  private initForm(): void {
    this.orderForm = this.fb.group({
      internalOrderId: ['', [Validators.required, Validators.minLength(1)]],
      companyName: ['', [Validators.required, Validators.minLength(2)]],
      mandantId: ['', [Validators.required, Validators.minLength(1)]],
      customerNr: ['', [Validators.required, Validators.minLength(1)]],
    });
  }

  private patchFormValues(order: IOrder): void {
    this.orderForm.patchValue({
      internalOrderId: order.internalOrderId,
      companyName: order.companyName,
      mandantId: order.mandantId,
      customerNr: order.customerNr,
    });
  }

  public get title(): string {
    return this.isEditMode ? 'Auftrag bearbeiten' : 'Auftrag hinzufügen';
  }

  public close(): void {
    this.modalClose(null);
  }

  @HostListener('document:keydown.escape', ['$event'])
  public handleEscape(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
    this.modalClose(null);
  }

  public submit(): void {
    if (this.orderForm.invalid) {
      this.orderForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    const formValue = this.orderForm.value;

    const order: IOrder = {
      ...(this.isEditMode && this.data?.order?._id ? { _id: this.data.order._id } : {}),
      internalOrderId: formValue.internalOrderId,
      companyName: formValue.companyName,
      mandantId: formValue.mandantId,
      customerNr: formValue.customerNr,
    };

    this.modalClose(order);
  }

  public isFieldInvalid(fieldName: string): boolean {
    const field = this.orderForm.get(fieldName);
    return field ? field.invalid && field.touched : false;
  }

  public getFieldError(fieldName: string): string {
    const field = this.orderForm.get(fieldName);
    if (!field || !field.errors) return '';

    if (field.errors['required']) return 'Dieses Feld ist erforderlich';
    if (field.errors['minlength']) return `Mindestens ${field.errors['minlength'].requiredLength} Zeichen`;

    return '';
  }
}
